import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=4ed4ee65"
import script from "./cashier.vue?vue&type=script&lang=ts"
export * from "./cashier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports